import Signup from "../features/auth/components/Signup";

export default function SignupPage() {
  return (
    <div>
      <Signup></Signup>
    </div>
  );
}
